export const attributes = [
    {
        "key": "name",
        "display": "Name",
        "text": "{{name|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "last_name",
        "display": "Last Name",
        "text": "{{last_name|fallback:\"one\"}}",
        "type": "paragraph"
    },
    {
        "key": "123",
        "display": "123",
        "text": "{{123|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "aman",
        "display": "aman",
        "text": "{{aman|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "colors",
        "display": "colors",
        "text": "{{colors|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "cakes",
        "display": "cakes",
        "text": "{{cakes|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Holidays",
        "display": "Holidays",
        "text": "{{Holidays|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "status",
        "display": "status",
        "text": "{{status|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "testing",
        "display": "testing",
        "text": "{{testing|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "joining date",
        "display": "joining date",
        "text": "{{joining date|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Decision",
        "display": "Decision",
        "text": "{{Decision|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "diwali",
        "display": "diwali",
        "text": "{{diwali|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "square",
        "display": "square",
        "text": "{{square|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "christmas",
        "display": "christmas",
        "text": "{{christmas|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "new year",
        "display": "new year",
        "text": "{{new year|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "decision two",
        "display": "decision two",
        "text": "{{decision two|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "critical",
        "display": "critical",
        "text": "{{critical|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "birthday",
        "display": "birthday",
        "text": "{{birthday|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "plans",
        "display": "plans",
        "text": "{{plans|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Tag",
        "display": "Tag",
        "text": "{{Tag|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Unsubscribed from Emails",
        "display": "Unsubscribed from Emails",
        "text": "{{Unsubscribed from Emails|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Marked email as spam",
        "display": "Marked email as spam",
        "text": "{{Marked email as spam|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Has hard bounced",
        "display": "Has hard bounced",
        "text": "{{Has hard bounced|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "UTM Campaign",
        "display": "UTM Campaign",
        "text": "{{UTM Campaign|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "UTM Content",
        "display": "UTM Content",
        "text": "{{UTM Content|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "UTM Medium",
        "display": "UTM Medium",
        "text": "{{UTM Medium|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "UTM Source",
        "display": "UTM Source",
        "text": "{{UTM Source|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "UTM Term",
        "display": "UTM Term",
        "text": "{{UTM Term|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Referral URL",
        "display": "Referral URL",
        "text": "{{Referral URL|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "WhatsApp number",
        "display": "WhatsApp number",
        "text": "{{WhatsApp number|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Name",
        "display": "Name",
        "text": "{{Name|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Account name",
        "display": "Account name",
        "text": "{{Account name|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Owner",
        "display": "Owner",
        "text": "{{Owner|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Owner name",
        "display": "Owner name",
        "text": "{{Owner name|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Lead category",
        "display": "Lead category",
        "text": "{{Lead category|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Conversation Rating",
        "display": "Conversation Rating",
        "text": "{{Conversation Rating|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Email",
        "display": "Email",
        "text": "{{Email|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Location",
        "display": "Location",
        "text": "{{Location|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "IP",
        "display": "IP",
        "text": "{{IP|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Phone",
        "display": "Phone",
        "text": "{{Phone|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "User ID",
        "display": "User ID",
        "text": "{{User ID|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "First Seen",
        "display": "First Seen",
        "text": "{{First Seen|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Signed up",
        "display": "Signed up",
        "text": "{{Signed up|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Last seen",
        "display": "Last seen",
        "text": "{{Last seen|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Last contacted",
        "display": "Last contacted",
        "text": "{{Last contacted|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Last heard from",
        "display": "Last heard from",
        "text": "{{Last heard from|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Last opened email",
        "display": "Last opened email",
        "text": "{{Last opened email|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Last clicked on link in email",
        "display": "Last clicked on link in email",
        "text": "{{Last clicked on link in email|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Web sessions",
        "display": "Web sessions",
        "text": "{{Web sessions|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Browser Language",
        "display": "Browser Language",
        "text": "{{Browser Language|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Language Override",
        "display": "Language Override",
        "text": "{{Language Override|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Browser",
        "display": "Browser",
        "text": "{{Browser|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "Browser Version",
        "display": "Browser Version",
        "text": "{{Browser Version|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "OS",
        "display": "OS",
        "text": "{{OS|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "figment",
        "display": "figment",
        "text": "{{figment|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "plan two",
        "display": "plan two",
        "text": "{{plan two|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "plan",
        "display": "plan",
        "text": "{{plan|fallback:\"there\"}}",
        "type": "paragraph"
    },
    {
        "key": "figmenttwo",
        "display": "figmenttwo",
        "text": "{{figmenttwo|fallback:\"there\"}}",
        "type": "paragraph"
    }
]